import styled from "styled-components";

export const DashboardsPageStyle = styled.div`

`;
